<template>
  <v-row
    class="full-area pa-0 ma-0"
    v-bind:style="{
      backgroundImage: 'url(' + site.bg_url + ')',
      backgroundColor: site.color,
    }"
    style="
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    "
  >
    <div style="position: absolute; right: 10px; top: 10px; z-index: 1">
      <SelectLangauge />
    </div>

    <v-col cols="12" class="d-flex align-center justify-center">
      <v-card
        class="rounded-xl"
        elevation="10"
        style="width: 100%; max-width: 420px"
      >
        <v-container>
          <div class="pa-7 pa-sm-12">
            <v-row no-gutters>
              <v-col cols="12">
                <div v-if="step == 1">
                  <v-col class="d-flex justify-center mb-0">
                    <v-avatar size="100px">
                      <img
                        :style="{
                          backgroundColor: site.color,
                        }"
                        :src="userLine.pictureUrl"
                      />
                    </v-avatar>
                  </v-col>
                  <p class="mt-0 blue-grey--text text--darken-2 text-center">
                    {{ userLine.displayName }} <br />
                  </p>
                  <h2
                    class="mt-6 mb-2 blue-grey--text text--darken-2 text-letf"
                  >
                    {{ $t("welcome") }}
                  </h2>
                </div>

                <v-window touchless v-model="step">
                  <v-window-item :value="1">
                    <v-form
                      ref="formRegister"
                      v-model="valid"
                      lazy-validation
                      class="justify-center"
                    >
                      <v-col class="pa-0">
                        <template v-if="key_login_type == 'phone'">
                          <p
                            class="blue-grey--text text--darken-2 text-left"
                            style="font-size: smaller"
                          >
                            {{ $t("instructionEnterRegisteredPhone") }}
                          </p>
                          <v-text-field
                            :color="site.color"
                            v-model="mobile"
                            :rules="phoneRules"
                            :placeholder="$t('phone')"
                            class="mt-4 rounded-lg"
                            maxlength="15"
                            type="number"
                            oninput="this.value=this.value.slice(0,this.maxLength)"
                            required
                            dense
                            outlined
                          ></v-text-field>
                        </template>
                        <template v-if="key_login_type == 'email'">
                          <p
                            class="blue-grey--text text--darken-2 text-left"
                            style="font-size: smaller"
                          >
                            {{ $t("instructionEnterRegisteredEmail") }}
                          </p>
                          <v-text-field
                            :color="site.color"
                            v-model="email"
                            :rules="emailRules"
                            :placeholder="$t('email')"
                            class="mt-4 rounded-lg"
                            required
                            dense
                            outlined
                          ></v-text-field>
                        </template>
                      </v-col>
                      <v-col class="text-center pa-0">
                        <v-btn
                          class="text-center white--text rounded-lg"
                          :disabled="!valid"
                          :color="site.color"
                          @click="checkUserIsExit()"
                        >
                          {{ $t("confirm") }}
                        </v-btn>
                      </v-col>
                    </v-form>
                  </v-window-item>
                  <v-window-item :value="2">
                    <v-form
                      ref="form"
                      v-model="valid"
                      lazy-validation
                      class="justify-center"
                    >
                      <h4 class="mt-4 blue-grey--text text--darken-2">
                        {{ $t("sendRefCodeOtp") }} : {{ ref_code }}
                      </h4>
                      <v-col
                        class="ma-auto position-relative px-0"
                        style="max-width: 250px"
                      >
                        <v-otp-input
                          :color="site.color"
                          v-model="OTP"
                          :rules="otpRules"
                          length="6"
                          type="number"
                          required
                          outlined
                          :disabled="loading"
                          @finish="checkOTP"
                        ></v-otp-input>
                      </v-col>
                      <p class="text-caption mb-2">
                        {{ $t("textRequireOTPAgain") }}
                        {{ formattedTimeLeft }}
                      </p>
                      <v-btn
                        x-small
                        text
                        color="red"
                        class="text-center pa-0 mb-2"
                        @click="sendOTP"
                        :disabled="disableBtnOTP"
                      >
                        {{ $t("requestOtpAgain") }}
                        <v-icon x-small> mdi-sync </v-icon>
                      </v-btn>
                      <v-col class="text-center pa-1">
                        <v-btn
                          class="text-center white--text rounded-lg"
                          :disabled="!valid"
                          :color="site.color"
                          @click="checkOTP"
                        >
                          {{ $t("confirm") }}</v-btn
                        >
                      </v-col>
                    </v-form>
                  </v-window-item>
                </v-window>
              </v-col>
            </v-row>
          </div>
        </v-container>

        <v-divider v-if="site.is_can_register == 'Y'"></v-divider>

        <v-card-actions
          class="text-center d-flex justify-center my-2"
          v-if="site.is_can_register == 'Y'"
        >
          {{ $t("textFirstRegistration") }} ?
          <p
            class="ma-0 ml-5 text-decoration-underline"
            style="color: #1e88e5; cursor: pointer"
            @click="redirectRegister"
          >
            {{ $t("textClickHere") }}
          </p>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import SelectLangauge from "../../../components/selectLangauge.vue";
import { getLandingPage } from "../../../config/general-function.js";

export default {
  components: { SelectLangauge },
  inject: ["isAppLoading"],
  data: () => ({
    valid: true,
    loading: false,
    mobile: "",
    step: 1,
    OTP: "",
    request_id: "",
    ref_code: "",
    TIME_LIMIT: 60,
    timePassed: 0,
    timerInterval: null,
    disableBtnOTP: true,
    key_login_type: "phone",
    email: "",
  }),
  created() {},
  methods: {
    checkUserIsExit() {
      if (!this.$refs.formRegister.validate(true)) {
        return;
      }
      this.isAppLoading(true);
      axios.defaults.headers.common["X-localization"] = this.$i18n.locale;
      axios
        .get(
          process.env.VUE_APP_CUSTOMER_SERVICE_MOBILE +
            `/checkUserIsExist?mobile=${this.mobile}`
        )
        .then((res) => {
          if (res.data.status == "success") {
            this.sendOTP();
          }
          if (res.data.status == "not_found") {
            this.$swal.fire({
              icon: "error",
              text: res.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
          } else if (res.data.status == "not_registered") {
            localStorage.setItem("mobile", this.mobile);
            this.redirectRegister();
            // this.$swal
            //   .fire({
            //     icon: "error",
            //     text: res.data.message,
            //     showCancelButton: false,
            //     confirmButtonText: this.$t("registerPage"),
            //   })
            //   .then((result) => {
            //     if (result.isConfirmed) {
            //       localStorage.setItem("mobile", this.mobile);
            //       this.redirectRegister();
            //     }
            //   });
          }
        })
        .catch((err) => {
          if (err.response.status === 400 || err.response.status === 500) {
            this.$swal.fire({
              icon: "error",
              text: err?.response?.data?.message || err.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    checkOTP() {
      if (!this.$refs.form.validate(true)) {
        return;
      }

      this.loading = true;
      this.isAppLoading(true);
      axios.defaults.headers.common["X-localization"] = this.$i18n.locale;
      axios
        .post(process.env.VUE_APP_CUSTOMER_SERVICE_MOBILE + `/login`, {
          request_id: this.request_id,
          code: this.OTP,
          mobile: this.mobile,
          line_id: this.userLine.userId ?? null,
          profile_path: this.userLine.pictureUrl ?? null,
          displayName: this.userLine.displayName ?? null,
          statusMessage: this.userLine.statusMessage ?? null,
        })
        .then((res) => {
          if (res.data.status == "success") {
            this.setToken(res.data.data.access_token);
            this.$swal
              .fire({
                icon: "success",
                text: res.data.message,
                showConfirmButton: false,
                timer: 3000,
              })
              .then(() => {
                let customer = {
                  ...(res.data.data.employee || {}),
                  status_consent: true,
                };
                this.$store.commit("defaultSystem/SET_CUSTOMER", customer);
                if (res.data.data.is_confirm_register == false) {
                  this.$store.commit(
                    "defaultSystem/SET_CONDITION",
                    res.data.data.terms_of_service.text
                  );
                  // ========== ========== Redirect & Reload ========== ==========
                  const landing_page = getLandingPage();
                  const targetRoute = this.$router.resolve({
                    name: landing_page,
                  });
                  window.location.href = targetRoute.href;
                } else if (this.urlRedirect) {
                  this.$router.push({
                    path: this.urlRedirect,
                  });
                  return;
                } else {
                  // ========== ========== Redirect & Reload ========== ==========
                  const landing_page = getLandingPage();
                  const targetRoute = this.$router.resolve({
                    name: landing_page,
                  });
                  window.location.href = targetRoute.href;
                }
              });
          }
        })
        .catch((err) => {
          this.OTP = "";
          if (err.response.status === 400 || err.response.status === 500) {
            this.$swal.fire({
              icon: "error",
              text: err?.response?.data?.message || err.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
      this.loading = false;
    },
    async setToken(accessToken) {
      return new Promise((resolve) => {
        localStorage.setItem("token", accessToken);
        resolve();
      });
    },
    sendOTP() {
      this.isAppLoading(true);
      if (!this.$refs.formRegister.validate(true)) {
        this.isAppLoading(false);
        return;
      }
      axios.defaults.headers.common["X-localization"] = this.$i18n.locale;
      axios
        .post(
          process.env.VUE_APP_CUSTOMER_SERVICE_MOBILE +
            `/sendOtp?mobile=${this.mobile}`
        )
        .then((res) => {
          if (res.data.status == "success") {
            this.$swal.fire({
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 1500,
            });
            this.step = 2;
            this.request_id = res.data.data.request_id;
            this.ref_code = res.data.data.ref_code;
            this.$store.commit("login/SET_MOBILE", { mobile: this.mobile });
            this.timePassed = 0;
            this.timerInterval = null;
            this.disableBtnOTP = true;
            this.startTimer();
          }
        })
        .catch((err) => {
          if (err.response.status === 400 || err.response.status === 500) {
            this.$swal.fire({
              icon: "error",
              text: err?.response?.data?.message || err.message,
              showConfirmButton: false,
              timer: 2000,
            });
          }
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    onTimesUp() {
      clearInterval(this.timerInterval);
    },
    startTimer() {
      this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
    },
    redirectLineLogin() {
      this.$router.push({
        name: "login-line",
      });
    },
    redirectRegister() {
      if (this.site?.register_detail) {
        let target = this.site?.register_detail.is_blank ? "_blank" : "_self";
        if (
          this.site?.register_detail.url !== null &&
          this.site?.register_detail.is_source_external == true
        ) {
          window.open(this.site?.register_detail.url, target);
        } else {
          this.$router.push({
            name: "register-bypass",
          });
        }
      } else {
        this.$router.push({
          name: "register-bypass",
        });
      }
    },
  },
  watch: {
    timeLeft(newValue) {
      if (newValue === 0) {
        this.onTimesUp();
        this.disableBtnOTP = false;
      }
    },
    // OTP(payload) {
    //   if (payload.length == 6) {
    //     this.checkOTP();
    //   }
    // },
  },
  mounted() {
    // // ชั่วคราวๆ ให้เป็นภาษาไทย
    // this.$store.commit("defaultSystem/SET_LANGUAGE", "th");
  },

  computed: {
    ...mapState("defaultSystem", ["site", "userLine"]),
    ...mapState("login", ["urlRedirect"]),
    phoneRules() {
      return [
        (v) => !!v || this.$t("validation.required"),
        (v) =>
          /^(08|06|09)\d{8}$/.test(v) || this.$t("validation.phoneInvalid"),
      ];
    },
    emailRules() {
      return [
        (v) => !!v || this.$t("validation.required"),
        (v) => /.+@.+\..+/.test(v) || this.$t("validation.emailInvalid"),
      ];
    },
    otpRules() {
      return [
        (v) => !!v || this.$t("validation.required"),
        (v) => /^[0-9]/.test(v) || this.$t("validation.numberInvalid"),
      ];
    },

    formattedTimeLeft() {
      const timeLeft = this.timeLeft;
      const minutes = Math.floor(timeLeft / 60);
      let seconds = timeLeft % 60;
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      return `${minutes}:${seconds}`;
    },
    timeLeft() {
      return this.TIME_LIMIT - this.timePassed;
    },
    timeFraction() {
      const rawTimeFraction = this.timeLeft / this.TIME_LIMIT;
      return rawTimeFraction - (1 / this.TIME_LIMIT) * (1 - rawTimeFraction);
    },
  },
};
</script>

<style scoped>
.full-area {
  color: rgba(0, 0, 0, 0.87);
}

.position-relative {
  position: relative;
}
</style>
